import { Button, DropDownInput } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useDispatch, useSelector } from "react-redux";
import { uploadCreditNote, uploadTransactions } from "../../../app/Slices";
import { useAlert, useConfirmationDialog } from "@/";
const walletTransactionBulk = ({ setSheetOpen = () => {} }) => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const handleChange = (key, value) => {
    setSelectedFile((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedFile, setSelectedFile] = useState({
    BulkWalletTransaction: null,
  });
  const handleUpload = async () => {
    if (!selectedFile.BulkWalletTransaction) {
      await alert("Please select a file before uploading.");
      return;
    }
    await confirm("Are you sure you want to upload the Transaction?");
    try {
      const action = await dispatch(
        uploadTransactions({ file: selectedFile.BulkWalletTransaction })
      );

      if (uploadTransactions.fulfilled.match(action)) {
        // Only close sheet after alert is acknowledged
        await alert(
          `${action.payload?.successful} out of ${
            Number(action.payload?.successful) + Number(action.payload?.failed)
          } Transactions Uploaded Successfully, refresh page to see changes.`
        );
        setSheetOpen(false);
      } else if (uploadTransactions.rejected.match(action)) {
        console.error("Transactions Upload Failed", action.payload);
        await alert(action.payload || "Transactions Upload Failed");
      }
    } catch (error) {
      console.error("API Error:::", error?.message || error);
      await alert("An error occurred while uploading the Transactions.");
    }
  };
  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download sample Wallet Transaction sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Admin_Wallet_Transaction.csv";
              }}
            >
              Sample Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated Wallet Transaction sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload  Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("BulkWalletTransaction", file)}
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>

        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleUpload}
        >
          Upload
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default walletTransactionBulk;
